import * as React from 'react'
import { SVGProps } from 'react'
const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={25} viewBox="0 0 27 25" width={27} {...props}>
    <mask fill="#fff" id="a">
      <path
        clipRule="evenodd"
        d="M2.81 2A2.81 2.81 0 0 0 0 4.81v9.893a2.81 2.81 0 0 0 2.81 2.81h.937v3.631c0 .506.615.754.966.39l3.885-4.02h14.82a2.81 2.81 0 0 0 2.81-2.81V4.81A2.81 2.81 0 0 0 23.419 2H2.81Z"
        fillRule="evenodd"
      />
    </mask>
    <path
      d="M3.747 17.514h.772v-.772h-.772v.772Zm.966 4.02.555.537-.555-.536Zm3.885-4.02v-.772h-.327l-.227.236.554.536ZM.771 4.81c0-1.126.913-2.039 2.04-2.039V1.23A3.582 3.582 0 0 0-.772 4.81H.77Zm0 9.893V4.81H-.77v9.893H.77Zm2.04 2.04a2.039 2.039 0 0 1-2.04-2.04H-.77a3.582 3.582 0 0 0 3.581 3.582v-1.543Zm.936 0H2.81v1.542h.937v-1.543Zm.772 4.401v-3.63H2.976v3.63h1.543ZM4.159 21a.21.21 0 0 1 .36.145H2.976c0 1.2 1.46 1.79 2.292.927l-1.11-1.072Zm3.885-4.021-3.885 4.02 1.11 1.073 3.884-4.021-1.11-1.072Zm15.374-.236H8.598v1.543h14.82v-1.543Zm2.04-2.039a2.039 2.039 0 0 1-2.04 2.04v1.542A3.582 3.582 0 0 0 27 14.703h-1.543Zm0-9.893v9.893H27V4.81h-1.543Zm-2.04-2.039c1.126 0 2.04.913 2.04 2.04H27a3.582 3.582 0 0 0-3.582-3.582V2.77Zm-20.608 0h20.608V1.23H2.81V2.77Z"
      fill="#000"
      mask="url(#a)"
    />
    <circle cx={6.053} cy={9.364} fill="#000" r={2.118} />
    <circle cx={13.114} cy={9.364} fill="#000" r={2.118} />
    <circle cx={20.176} cy={9.364} fill="#000" r={2.118} />
  </svg>
)
export default SvgChat
